<div *ngIf="view && view.data" class="edit-frame" [ngClass]="{'is-saving':isSaving}">
  <div class="breadcrumb-holder">
    <span>
      <a routerLink="/data-models/{{view?.type}}">{{view?.type|friendlyType}}</a>
      <span class="breadcrumb-seperator"> <i class="fas fa-chevron-right" style="font-size:10px;"></i> </span>
      <span>{{view?.mode}}</span>
    </span>
  </div>
  <div class="scaffold-page-buttons">
    <button nbButton status="basic" (click)="cancel()">{{'cancel'| translation}}</button>
    <button nbButton status="primary" [nbSpinner]="isSaving" nbSpinnerStatus="basic" class="pull-right" (click)="savePage()">{{'save'| translation}}</button>
  </div>
  <nb-card>
    <nb-card-body>
      <div>
        <nb-form-field>
          <input nbInput placeholder="Friendly Name" [(ngModel)]="view.data.title">
        </nb-form-field>
      </div>
      <!--<div>
        <scaffold-toggle-slide [(ngModel)]="view.data.showHistory">Show Version Controls</scaffold-toggle-slide>
      </div>-->
    </nb-card-body>
  </nb-card>

  <div class="saving-screen-cover">
    <div>
      <p>{{'saving'| translation}}...</p>
      <scaffold-loading-animation></scaffold-loading-animation>
    </div>
  </div>
</div>
<nb-tabset>
  <nb-tab tabTitle="Editor">
    <app-editor *ngIf="view" [parentView]="view" [info]="view" [undoService]="undoService" [(items)]="content" [parents]="[{type:'editor'}]" [data]="{}"></app-editor>
  </nb-tab>
  <nb-tab tabTitle="JSON Data">
    <scaffold-json-editor *ngIf="view?.data" [(json)]="_content" [readonly]="false"></scaffold-json-editor>

  </nb-tab>
</nb-tabset>
